export type ICounselor = {
  id: string
  name: string
  character: string
  description: string
  quote: string
  details: string
  color: string
}

interface ISelectManagerListProps {
  counselors: ICounselor[]
  selectedCounselor: ICounselor
  handleCounselorSelect: (counselor: ICounselor) => void
}

const SelectManagerList = ({ counselors, selectedCounselor, handleCounselorSelect }: ISelectManagerListProps) => {
  return (
    <div className='flex justify-center gap-8 mb-6'>
      {counselors.map(counselor => (
        <button
          key={counselor.id}
          onClick={() => handleCounselorSelect(counselor)}
          className={`flex flex-col items-center transition-all duration-300 ${
            selectedCounselor.id === counselor.id ? 'scale-110' : 'opacity-70 hover:opacity-90 hover:scale-105'
          }`}
        >
          <div
            className={`w-16 h-16 rounded-full flex items-center justify-center text-2xl mb-2 shadow-lg border-2 ${
              selectedCounselor.id === counselor.id ? 'border-amber-400' : 'border-white'
            } ${
              counselor.id === 'caring' ? 'bg-yellow-400' : counselor.id === 'direct' ? 'bg-gray-400' : 'bg-orange-400'
            }`}
          >
            {counselor.character}
          </div>
          <span className='text-sm font-medium text-amber-900'>{counselor.name}</span>
        </button>
      ))}
    </div>
  )
}

export default SelectManagerList
